import { APP_INITIALIZER, Injector } from '@angular/core';

import { AccountService } from 'lib/services/account/account.service';
import { CartService } from 'lib/services/cart/cart.service';
import { CategoryComponent } from './category/category.component';
import { CategoryService } from 'lib/services/category/category.service';
import { ExxComError } from 'lib/classes/exxcom-error.class';
import { GtmService } from 'lib/services/google/gtm.service';
import { MetaService } from 'lib/services/meta.service';
import { RouterService } from 'lib/services/router.service';
import { SessionService } from 'lib/services/session.service';
import { StripeService } from 'lib/services/stripe/stripe.service';
import { WebstoreProductService } from 'lib/services/webstore-product/webstore-product.service';
import { WebpService } from 'lib/services/webp.service';

const scriptName = 'app.initializers';

export const ServicesInitializer = {
    provide: APP_INITIALIZER,
    deps: [Injector],
    multi: true,
    useFactory: function initServices(injector: Injector): () => Promise<any> {
        return async () => {
            try {
                injector.get(RouterService).init(); // Has to be called first because it is used in many services

                await injector.get(SessionService).init();
                const asyncInitializers = [
                    // The functions in each array element are all called at the same time
                    (async () => {
                        await injector.get(AccountService).init(); // Has to be called after SessionService
                        await injector.get(CartService).init(); // Has to be called after SessionService and AccountService
                        await injector.get(WebpService).setWebpAvailable();
                    })(),
                    (async () => {
                        await injector.get(CategoryService).initRoutes(CategoryComponent);
                        await injector.get(CategoryService).loadCategoryPriceCeilings(); // Populate category price ceilings before products build pricing
                        injector.get(MetaService).init(); // Has to be called after CategoryService
                        injector.get(GtmService).init(); // Has to be called after MetaService
                    })(),
                    injector.get(WebstoreProductService).init(),
                    injector.get(StripeService).init(),
                    // injector.get(MarketoService).init(),
                ];
                await Promise.all(asyncInitializers);
            } catch (err) {
                console.error(...new ExxComError(234627, scriptName, err).stamp());
            }
        };
    },
};
